import { SimpleIconProps } from '../types';

export const IconChevron = (props: SimpleIconProps) => {
  return (
    <svg fill="none" height="32" role="img" viewBox="0 0 32 32" width="32" {...props}>
      <path
        d="M26.6667 21.3333L16 10.6666L5.33335 21.3333"
        stroke={props.stroke ?? '#18497A'}
        strokeWidth="2.66667"
      />
    </svg>
  );
};
